let countdownInterval = null;
const TIMER_STORAGE_KEY = "shopify_cart_timer_end_time";
const TIMER_EXPIRED_KEY = "shopify_cart_timer_expired";

// Start or resume countdown
const startCountdownTimer = (remainingSeconds = null) => {
  const minutesEl = document.getElementById("cart-timer-minutes");
  const secondsEl = document.getElementById("cart-timer-seconds");

  if (!minutesEl || !secondsEl) {
    console.log("Timer elements not found.");
    return;
  }

  const now = Date.now();
  let endTime;

  if (remainingSeconds !== null) {
    endTime = now + remainingSeconds * 1000;
  } else {
    endTime = now + 10 * 60 * 1000; // 10 minutes
    localStorage.setItem(TIMER_STORAGE_KEY, endTime.toString());
    localStorage.removeItem(TIMER_EXPIRED_KEY);
  }

  if (countdownInterval) clearInterval(countdownInterval);

  countdownInterval = setInterval(() => {
    const currentTime = Date.now();
    const remainingMs = endTime - currentTime;
    const totalSeconds = Math.floor(remainingMs / 1000);

    if (totalSeconds <= 0) {
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      clearInterval(countdownInterval);
      localStorage.setItem(TIMER_EXPIRED_KEY, "true");
      return;
    }

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    minutesEl.textContent = minutes.toString().padStart(2, "0");
    secondsEl.textContent = seconds.toString().padStart(2, "0");
  }, 1000);
};

// Insert the timer block
const insertCountdownTimer = () => {
  if (!document.getElementById("cart-timer-message")) {
    const timer = document.createElement("div");
    timer.id = "cart-timer-message";
    timer.style.cssText =
      "padding: 15px; background: #fff7e6; border: 1px solid #f5c26b; margin-bottom: 20px; font-weight: 600; text-align: center; border-radius:10px;";
    timer.innerHTML = `
      Complete your order within 
      <span id="cart-timer-minutes">--</span> minutes, 
      <span id="cart-timer-seconds">--</span> seconds to avoid losing your items.
    `;
    const cartTitle = document.querySelector("#cart_titles"); // adjust selector if needed
    if (cartTitle) {
      cartTitle.insertAdjacentElement("afterend", timer);
    }
  }

  const now = Date.now();
  const endTime = parseInt(localStorage.getItem(TIMER_STORAGE_KEY), 10);
  const expired = localStorage.getItem(TIMER_EXPIRED_KEY) === "true";

  if (expired) {
    // Timer has expired - show 00:00 until cart updates
    const minutesEl = document.getElementById("cart-timer-minutes");
    const secondsEl = document.getElementById("cart-timer-seconds");
    if (minutesEl && secondsEl) {
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
    }
    return;
  }

  if (endTime && endTime > now) {
    const remainingSeconds = Math.floor((endTime - now) / 1000);
    startCountdownTimer(remainingSeconds);
  } else {
    startCountdownTimer(); // start fresh
  }
};

// Remove the timer but keep the timer state in localStorage
const removeCountdownTimer = () => {
  const timer = document.getElementById("cart-timer-message");
  if (timer) {
    timer.remove();
    clearInterval(countdownInterval);
    // Don't remove the timer storage keys here
  }
};

// Check cart and update timer
const checkCartAndUpdateTimer = () => {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const expired = localStorage.getItem(TIMER_EXPIRED_KEY) === "true";
      const endTime = parseInt(localStorage.getItem(TIMER_STORAGE_KEY), 10);
      const now = Date.now();

      if (cart.item_count > 0) {
        // Reset timer if cart was changed after expiry
        if (expired) {
          localStorage.removeItem(TIMER_EXPIRED_KEY);
          startCountdownTimer(); // Start new timer when cart changes after expiry
        }
        insertCountdownTimer();
      } else {
        // Cart is empty - just remove the timer display but keep the timer running
        removeCountdownTimer();

        // If timer was expired before cart became empty, clear the expired flag
        if (expired) {
          localStorage.removeItem(TIMER_EXPIRED_KEY);
        }
      }
    })
    .catch((err) => {
      console.error("Error fetching cart:", err);
    });
};

// Watch for cart updates
const watchForAjaxAddToCart = () => {
  document.addEventListener("cart:updated", checkCartAndUpdateTimer);
  document.addEventListener("product:added", checkCartAndUpdateTimer);

  // Fallback: monitor DOM changes
  const cartContainer =
    document.querySelector("#ajaxifyCart") ||
    document.querySelector(".cart__items");
  if (cartContainer) {
    const observer = new MutationObserver(() => {
      checkCartAndUpdateTimer();
    });
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
};

// Init
document.addEventListener("DOMContentLoaded", () => {
  checkCartAndUpdateTimer();
  watchForAjaxAddToCart();
});


  const hello = document.getElementById('hello');

  let lastPosition = 100;
  function animate() {
    const currentTransform = getComputedStyle(hello).transform;

    if (currentTransform !== 'none') {
      const matrix = new DOMMatrix(currentTransform);
      const x = matrix.m41; // current X position

      // Hide when near -90%
      if (x <= -window.innerWidth * 0.9) {
        hello.style.visibility = 'hidden';
      }

      // Show when coming back from +90%
      if (x >= window.innerWidth * 0.9) {
        hello.style.visibility = 'visible';
      }
    }

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);






